export default {
  'Custom': 'Personalizado',
  'Original': 'Original',
  'Resolution': 'Resolução',
  'Frame rate': 'Taxa de quadros',
  'The higher the frame rate, the smoother the animation': 'Quanto maior a taxa de quadros, mais suave será a animação.',
  'Start': 'Início',
  'End': 'Fim',
  'Create GIF': 'Criar GIF',
  'Download GIF': 'Baixar GIF',
  'Create A New One': 'Criar Um Novo',
  'Remake GIF': 'Refazer GIF',
  'HitPaw Video to GIF Online': 'Vídeo para GIF Online HitPaw',
  'Upload and convert video to GIF without any difficulty': 'Faça upload e converta vídeo em GIF sem qualquer dificuldade',
}